import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import app from 'bundles/workspaces-app/app/app';

export default appStarterFactory(app);
